import React from "react";

export default function MasteredIcon(props) {
  return <span className="glyphicon glyphicon-ok-circle mastered-count-icon" style={props.style}></span>;
}
